import hyperHTML from 'hyperhtml';

export default (renderer, data, events) => {
  const inputClass = ['e-input', 'e-numberinput__input'];

  if (data.size) {
    inputClass.push(`e-numberinput__input-${data.size}`);
  }

  if (!data.isValid || data.isForceInvalid) {
    inputClass.push('e-input-error');
  }

  const style = data.size ? 'display: inline-block;' : '';

  const downArrowClass = ['e-btn e-btn-borderless e-btn-onlyicon', 'e-numberinput__arrow e-numberinput__arrow-down'];
  const upArrowClass = ['e-btn e-btn-borderless e-btn-onlyicon', 'e-numberinput__arrow e-numberinput__arrow-up'];

  if (data.isArrowDownDisabled) {
    downArrowClass.push('e-btn-disabled');
  }

  if (data.isArrowUpDisabled) {
    upArrowClass.push('e-btn-disabled');
  }

  const arrows = (events) => {
    return hyperHTML.wire(events, ':arrows')`
      <div>
        <div class=${upArrowClass.join(' ')} onmousedown=${events.increase}>
          <e-icon icon="e-move-up"></e-icon>
        </div>
        <div class=${downArrowClass.join(' ')} onmousedown=${events.decrease}>
          <e-icon icon="e-move-down"></e-icon>
        </div>
      </div>
    `;
  };

  data.inputElement = hyperHTML.wire(data, ':input-element')`
    <input class=${inputClass.join(' ')} type="text"
      value=${data.isFocused || !data.isValid ? data.value : data.displayValue}
      placeholder=${data.placeholder}
      onkeydown=${events.keyDown}
      onfocus=${events.focus}
      onblur=${events.blur}
      oninput=${events.input}
      onchange=${events.change}
      disabled=${data.disabled}
    >
  `;

  renderer`
    <div class="e-numberinput" style=${style}>
      ${data.inputElement}
      ${data.disabled ? '' : arrows(events)}
    </div>
    <input type="hidden" value=${data.value} name=${data.name} disabled=${data.disabled}>
  `;
};
